import { Box } from "@mui/material";

/**
 * Badge de status usado nas colunas "Validação" das abas da Apuração ICMS
 * (TXM-473 ICMS-ST, TXM-600 Contribuições) — mesmo formato de pílula dos badges
 * do cabeçalho (detalhe.styles.module.css .badgeTipo/.badgeGrupo), mas com a cor
 * decidida pelo tom semântico.
 */
const TONS = {
  ok: { bgcolor: "#e6f4ea", color: "#1e7a3c" },
  alerta: { bgcolor: "#fdf6e3", color: "#8a6100" },
  neutro: { bgcolor: "#eef1f5", color: "#4a5568" },
};

export default function BadgeStatus({ tom = "neutro", children }) {
  const cores = TONS[tom] || TONS.neutro;
  return (
    <Box
      component="span"
      sx={{
        display: "inline-block",
        padding: "3px 10px",
        borderRadius: "20px",
        fontSize: "0.72rem",
        fontWeight: 600,
        whiteSpace: "nowrap",
        ...cores,
      }}
    >
      {children}
    </Box>
  );
}
